import { ListTypeEnum } from 'APIPackage/CatalogsModule/enums/ListTypeEnum';
import { IListType } from 'APIPackage/CatalogsModule/interfaces/IListType';
import { ErknmPlanStatusesEnum } from 'APIPackage/PlanListModule/enums/ErknmPlanStatusesEnum';
import { IListTypeSelectOption } from 'CorePackage/CatalogsModule/interfaces/IListTypeSelectOption';

export function filterListTypesByPlanStatus<ListType extends IListType | IListTypeSelectOption>(
  listTypes: ListType[],
  planStatus: ErknmPlanStatusesEnum | undefined,
): ListType[] {
  return listTypes.filter(item => {
    switch (planStatus) {
      case ErknmPlanStatusesEnum.IN_PROCESS: {
        return (
          item.type === ListTypeEnum.TOTAL ||
          item.type === ListTypeEnum.FILL_IN_PROCESS ||
          item.type === ListTypeEnum.READY_FOR_APPROVE
        );
      }
      case ErknmPlanStatusesEnum.UNDER_CONSIDERATION: {
        return (
          item.type === ListTypeEnum.TOTAL ||
          item.type === ListTypeEnum.EXCLUDED ||
          item.type === ListTypeEnum.AGREED ||
          item.type === ListTypeEnum.COMMENTS_EXIST ||
          item.type === ListTypeEnum.UNDER_CONSIDERATION
        );
      }
      case ErknmPlanStatusesEnum.CONSIDERED: {
        return (
          item.type === ListTypeEnum.TOTAL ||
          item.type === ListTypeEnum.EXCLUDED ||
          item.type === ListTypeEnum.AGREED ||
          item.type === ListTypeEnum.COMMENTS_EXIST ||
          item.type === ListTypeEnum.APPEALED
        );
      }
      case ErknmPlanStatusesEnum.APPROVED: {
        return (
          item.type === ListTypeEnum.TOTAL ||
          item.type === ListTypeEnum.AGREED ||
          item.type === ListTypeEnum.EXCLUDED ||
          item.type === ListTypeEnum.UNDER_CONSIDERATION
        );
      }
      default:
        return item;
    }
  });
}
